import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';

export const useCountdown = (
  time: DateTime
): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  complete: boolean;
} => {
  const [_, forceUpdate] = useState<number>();

  const isComplete = useCallback(() => time.diffNow().milliseconds < 0, [time]);

  useEffect(() => {
    let value = 0;

    const interval =
      !isComplete() &&
      setInterval(() => {
        forceUpdate(++value);
      }, 1000);

    return (): void => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isComplete, time]);

  const { days, hours, minutes, seconds } = time.diff(DateTime.now(), [
    'hours',
    'days',
    'minutes',
    'seconds'
  ]);

  return {
    days: Math.round(hours) === 24 ? days + 1 : days,
    hours: Math.round(minutes) === 60 ? hours + 1 : Math.round(hours) % 24,
    minutes: Math.round(seconds) === 60 ? minutes + 1 : Math.round(minutes) % 60,
    seconds: Math.round(seconds) % 60,
    complete: isComplete()
  };
};
